import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d1713034b9ae001473d385/vocedlms/src/app/admin-setup/page.tsx");
